// extracted by mini-css-extract-plugin
export default {"selectIconItem":"styles_selectIconItem__--TTF"};